import styles from './BotModal.module.css';

const BotModal = ({ bot, onClose }) => {
  if (!bot) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2>Bot Details</h2>
        <ul className={styles.detailList}>
          <li><strong>ID:</strong> {bot.id}</li>
          <li><strong>User ID:</strong> {bot.user_id}</li>
          <li><strong>Coin:</strong> {bot.coin_symbol}</li>
          <li><strong>Status:</strong> {bot.bot_status ? 'Running' : 'Stopped'}</li>
          <li><strong>Buy Count:</strong> {bot.buy_count}</li>
          <li><strong>Balance Enough:</strong> {bot.balance_enough ? 'Yes' : 'No'}</li>
          <li><strong>Error Status:</strong> {bot.error_status || '-'}</li>
          <li><strong>Created At:</strong> {new Date(bot.created_at).toLocaleString()}</li>
          <li><strong>Updated At:</strong> {new Date(bot.updated_at).toLocaleString()}</li>
        </ul>
        <div className={styles.footer}>
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default BotModal;
